import { useCallback } from 'react';

import countries from 'src/shared/helpers/countries.json';

import { signupValues, updateSignupValues, resetSignupValues } from '../utils/signup-storage';
import { CurrencyType } from '../components/plan';

export type StepsCompleted = {
    accountCreation?: false;
    businessDetails?: false;
    selectPlan?: false;
    payment?: false;
};

export type UserLocation = {
    countryCode: string | null;
    continentCode: string | null;
};

export type Fields = {
    // User's Country
    userLocation?: UserLocation;
    // Account Creation
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    // Business Details
    businessName?: string | null;
    category?: {
        value: number;
        label: string;
    };
    numberOfLocations?: number; // numeric value coming from NearMeCheckContext
    numberOfLocationsRange?: string; // string value representing selected range of location number
    country?: keyof typeof countries;
    // Import information - Near Me Check information
    nearMeCheck?: {
        id: number;
        token?: string;
        isSingleLocationCheck?: boolean;
    } | null;
    // Plans
    isFreePlan?: boolean;
    planId?: number;
    locationImport?: boolean;
    // Billing/Payment Information
    selectedCurrency?: CurrencyType;
    paymentMethod?: string;
    salesPartnerId?: number | null;
    // Pages completed
    stepsCompleted?: StepsCompleted;
};

export const useSignUpData = () => {
    const storageValues: Fields = signupValues();

    const updateField = useCallback((values: Fields) => {
        updateSignupValues(values);
    }, []);

    const resetValues = useCallback(() => {
        resetSignupValues();
    }, []);

    return { ...storageValues, updateField, resetValues };
};
